export default {
    state: {
        all: [],
        filtered: [],
        selectedProject: {}
    },
	actions: {
		async loadProjects({ commit }) {
			await axios.get('/api/projects').then(projects => {
				commit('setProjects', projects)
			}).catch(response => {
				console.error(response);
			});
		},

		// KAN-173: Slim version for map/list pages — only loads fields needed for
		// markers and dropdowns. Full detail loads on-click via loadProject.
		async loadProjectsMap({ commit }) {
			await axios.get('/api/projects/map').then(projects => {
				commit('setProjects', projects)
			}).catch(response => {
				console.error(response);
			});
		},

		async loadProject({ commit }, projectID) {
			await axios.get(`/api/project/${projectID}`).then(project => {
				commit('setSelectedProject', project.data)
			}).catch(response => {
				console.error(response);
			});
		}
	},
	mutations: {
		setProjects(state, projects) {
			state.all = projects.data
			state.filtered = projects.data
		},

		setSelectedProject(state, project) {
			state.selectedProject = project;
		}
	},
	getters: {
		projectsSortedBy: (state) => (fields) => {
			return _.sortBy(state.all, fields);
		},

		compsSortedBy: (state) => {
			return _.sortBy(state.selectedProject.comps, 'address_line_1');
		}
	}
};